import isNil from 'lodash-es/isNil';
import { isHydricStress } from '../../enums/MetricIds';
import { thresholdColorScale } from '../dss/irrigation';
import { getColorScalePerMetric, getYDomainPerMetric } from '../measurements';
/** grayscale.100 */
export const MARKER_DEFAULT_COLOR = '#E6EAEB';
export const getMarkerColorScale = (focusedMetricId, timeStep) => {
    if (isNil(focusedMetricId)) {
        return () => MARKER_DEFAULT_COLOR;
    }
    const finalFocusedMetricId = focusedMetricId === 'FXY' ? 'FF' : focusedMetricId;
    // use rawValue so we don't use unit dependant domain
    const domain = getYDomainPerMetric({ metric: finalFocusedMetricId, timeStep });
    return getColorScalePerMetric(finalFocusedMetricId)(domain);
};
export const getMarkerBackgroundColor = ({ isRestricted, colorScale, colors, focusedMetricId, rawValue, threshold }) => {
    let result = MARKER_DEFAULT_COLOR;
    const isHydricStressMetric = !isNil(focusedMetricId) && isHydricStress(focusedMetricId);
    const isHydricDeficitMetric = !isNil(focusedMetricId) && focusedMetricId === 'HDEF';
    if (isRestricted) {
        result = colors.grayscale.black;
    }
    else if (!isNil(rawValue)) {
        if ((isHydricStressMetric || isHydricDeficitMetric) && !isNil(threshold)) {
            result = thresholdColorScale(threshold);
        }
        else if (focusedMetricId === 'DD') {
            result = colors.metrics.DD[500];
        }
        else if (focusedMetricId === 'LW_D') {
            result = colors.metrics.LW_D[500];
        }
        else if (focusedMetricId === 'PPFD' ||
            focusedMetricId === 'PPFD_MAX' ||
            focusedMetricId === 'PPFD_MIN') {
            result = colors.metrics.PPFD[500];
        }
        else {
            // use rawValue so we don't use unit dependant domain
            result = colorScale(rawValue);
        }
    }
    return result;
};
